export const rowCustomHandlerType = {
    HYPPER_LINK: 'hypper-link',
    EDIT: 'edit',
    DELETE: 'delete',
    DETAIL: 'detail',
    CONFIRM: 'confirm',
    TOGGLE: 'toggle'
}